import { IFormDropdownProps } from 'cng-common/features/form/components/formDropdown/models'
import { OnboardingFormDropdown } from 'onboarding/components/ui/theme'

import { TAdaptingDisabled } from './types'

export const OnboardingFormDropdownAdapter = <T,>({
  disabled,
  isDisabled,
  ...props
}: IFormDropdownProps<T> & TAdaptingDisabled) => (
  <OnboardingFormDropdown {...props} isDisabled={isDisabled || disabled} />
)
